<div class="mt-4">
    <app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
    <div class="col-md-3 ms-5 ps-5 mt-4">
        <div class="mb-1 fw-bold">
            <label>Buscar </label>
        </div>
        <div class="input-group">
            <span class="input-group-text fondo-blanco color-gris cursor" (click)="buscar(texto.value)"><i class="fa-solid fa-magnifying-glass"></i></span>
            <input type="text" class="form-control lineas-buscadores" placeholder="Nombre funcionalidad" #texto id="caja">
            <span class="input-group-text fondo-blanco color-gris cursor" (click)="borrar()" id="cancel">
                <i class="fa-solid fa-circle-xmark"></i>
            </span>
        </div>
    </div>
    <div class="ms-5 me-5 ps-5 pe-5 mt-4">
        <table class="table" aria-describedby="mydesc">
            <thead class="fondo-gris">
                <tr class="text-center">
                    <th scope="col">Sigla</th>
                    <th scope="col">Aplicación</th>
                    <th scope="col">Roles</th>
                    <th scope="col">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let func of lista | paginate: { itemsPerPage: 10, currentPage: pagina }" class="text-center">
                    <td class = 'col-1'>{{ func.siglaAplicativo }}</td>
                    <td class = 'col-4'>{{ func.nombreAplicativo }}</td>
                    <td class="col-2">{{ func.roles }}</td>
                    <td class="col-2">
                        <a class="text-primary cursor" [routerLink]="['crear-funcionalidad', func.idAplicativo]">
                            <i class="fa fa-marker fa-lg"></i>
                        </a>
                        <a *ngIf="func.estado=='Habilitado'" class="text-danger cursor ms-5 me-2" (click)="desactivarFuncionalidad(func)">
                            <i class="fa fa-minus-circle fa-lg"></i>
                        </a>
                      <a *ngIf="func.estado!='Habilitado'"  class="text-success cursor ms-5 me-2" (click)="activarFuncionalidad(func)">
                        <i class="fa fa-circle-plus fa-lg"></i>
                      </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-between mt-2">
            <button class="btn btn-outline-primary rounded-pill" (click)="crearFuncionalidad()">CREAR NUEVA FUNCIONALIDAD</button>
            <pagination-controls class="clase-paginador" (pageChange)="pagina = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
        </div>
    </div>
</div>
